module.exports = __webpack_public_path__ + "static/img/recruit-process.31b48f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/campusJob/recruit-process.png
// module id = 626
// module chunks = 12